function load(component) {
    return () =>import (`@/components/${component}.vue`);
};
export default{
    path: "/question",
    component: load("dashboard"),
    children: [
        {
            path: "",
            name: "question",
            component: load("question/Index"),
            meta: {
                parent: 'sale',
                child: 'quotation',
                deal: false
            }
        },
        {
            path: "create",
            name: "create-question",
            component: load("question/Create"),
            meta: {
                parent: 'sale',
                child: 'quotation',
                deal: true
            }
        },
        {
            path: "detail/:id",
            name: "sale-detail",
            component: load("question/Detail"),
            meta: {
                parent: 'sale',
                child: 'quotation',
                deal: false
            }
        }
    ]
}



// WEBPACK FOOTER //
// ./src/router/question.js